<script setup lang="ts">
navigateTo("/login");
</script>
<template></template>
